<template>
    <v-overlay v-if="loading" opacity="0.6" :absolute="isComponent">
        <v-row class="ma-0" justify="center">
            <v-progress-circular indeterminate color="secondary" :size="60" :width="8">
            </v-progress-circular>
        </v-row>
        <v-row class="ma-0 page-subtitle" style="color: #ffeb3b">
            {{ loadingText }}
        </v-row>
    </v-overlay>
</template>

<script>
export default {
    name: "BrebLoading",
    components: {

    },
    mixins: [],
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isComponent: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: 'Loading, please wait...',
        }
    },
    data: function () {
        return {

        }
    },
    computed: {
        mobile() {
            return this.$vuetify.breakpoint.mobile
        },
        cellphone() {
            return this.$vuetify.breakpoint.xs
        },
    },
    watch: {

    },
    methods: {

    },
    created() {

    },
    beforeMount() {

    },
    mounted() {

    },
    beforeDestroy() {

    },

}
</script>

<style scoped></style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@import 'node_modules/vuetify/src/styles/settings/variables';
@import "src/globals";
@media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {}
</style>